/* eslint-disable object-curly-newline */
/* eslint-disable object-curly-newline */
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
import { getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { Card, CardBody, Modal as ModalCustom } from 'reactstrap';
import cx from 'classnames';
import ModalHeader from '@components/Modal/ModalHeader';
import rendererOptions from '@richtextRendering/renderer-options';
import Expand from './Expand_Button_2x.png';

/**
 * Takes card data and renders it
 * as a Gallery Content Card for a Media Gallery.
 */
const GalleryContentCard = ({ card }) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const { border } = card;

  const customImage = getImage(card.cardImage?.gatsbyImageData || card.image?.gatsbyImageData)['images']['fallback']['src'];
  const customThumbnail = card.thumbnail ? getImage(card.thumbnail?.gatsbyImageData)['images']['fallback']['src'] : null;
  return (
    <div style={{ padding: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card className={cx('mb-3', 'data-cy-card-button', 'content-card', border ? 'card-no-border' : 'card-border')} style={{ width: 300, height: 300, backgroundSize: 'cover', backgroundPosition: 'center', cursor: 'pointer', backgroundImage: `url(${card.thumbnail ? customThumbnail : customImage})` }} onClick={toggle}>
        <>
          <CardBody className="card-body-custom" />
          <div className="expand-icon" style={{ zIndex: 9999, width: '5px', marginBottom: '-95px', marginRight: '10px', position: 'absolute', right: 70, top: 10, cursor: 'pointer' }}>
            <img src={Expand} alt="expand" />
          </div>
          <ModalCustom size="lg" isOpen={modal} centered backdropClassName="backdrop-class" className="modal-class" backdrop toggle={toggle}>
            <ModalHeader toggle={toggle} />
            <img src={customImage} alt="card" style={{ width: '100%' }} />
            {card.caption && (
            <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', color: 'white', position: 'absolute', bottom: '0', padding: '10px', width: '100%' }}>
              {renderRichText(card.caption, rendererOptions)}
            </div>
            )}
          </ModalCustom>
        </>
      </Card>

    </div>
  );
};

GalleryContentCard.defaultProps = {
  card: null,
};

GalleryContentCard.propTypes = {
  // TODO: Fix this eslint warning and remove whitelisting
  // eslint-disable-next-line react/forbid-prop-types
  card: PropTypes.objectOf(PropTypes.any),
};

export default GalleryContentCard;
